// 通过 JS 添加样式

const el = document.querySelector('._1fragemu5');
if (el) el.style.cssText = 'display: flex;';
// const el = document.querySelector('._1fragemu5');
// el.style.cssText = 'display: flex;';